import React from "react"
import { FormDateOfBirthInput } from "components/views/atoms/forms/FormDateOfBirthInput"
import { Asterisk, Label, Spacer } from "components/views/atoms/Atoms"
import { Moment } from "moment"
import { useIntl } from "react-intl"

type DateOfBirthProps = {
  dateOfBirth?: Moment
  dateOfBirthRef: any
  validDateOfBirth: boolean
  showAsterisk?: boolean
  showLabel?: boolean
}

export default function DateOfBirth({
  dateOfBirth,
  dateOfBirthRef,
  validDateOfBirth,
  showAsterisk = false,
  showLabel = true
}: DateOfBirthProps): JSX.Element {
  const intl = useIntl()
  return (
    <>
      <div className="flex flex-row">
        <div className="flex-auto" style={{ flexBasis: 0 }}>
          <Label htmlFor="dateOfBirth" valid={validDateOfBirth}>
            {showLabel ? intl.formatMessage({ defaultMessage: "Month" }) : null}
            {showAsterisk ? <Asterisk /> : null}
          </Label>
        </div>
        <Spacer width={1} />
        <div className="flex-auto" style={{ flexBasis: 0 }}>
          <Label htmlFor="dateOfBirth" valid={validDateOfBirth}>
            {showLabel ? intl.formatMessage({ defaultMessage: "Day" }) : null}
            {showAsterisk ? <Asterisk /> : null}
          </Label>
        </div>
        <Spacer width={1} />
        <div className="flex-auto" style={{ flexBasis: 0 }}>
          <Label htmlFor="dateOfBirth" valid={validDateOfBirth}>
            {showLabel ? intl.formatMessage({ defaultMessage: "Year" }) : null}
            {showAsterisk ? <Asterisk /> : null}
          </Label>
        </div>
      </div>
      <Spacer height={0.5} />
      {/*@ts-ignore*/}
      <FormDateOfBirthInput dateOfBirth={dateOfBirth} ref={dateOfBirthRef} />
    </>
  )
}
